import * as z from 'zod';

const SeoTitleTagZod = z.enum(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p']);

export { SeoTitleTagZod };
export type SeoTitleTag = z.infer<typeof SeoTitleTagZod>;
